module.exports = __webpack_public_path__ + "img/logo-nav.df0c3c9.svg";